import React from 'react';
import { useNumberInput } from '@chakra-ui/react';
import { CategorySummary } from 'api/types';

import { QuantityInput } from '../../../../../common/components/QuantityInput/QuantityInput';

type Props = {
  category: CategorySummary;
  updateQuantityOfItemsInCategory: (categoryId: string, quantity: number) => void;
  categoryQuantity: number;
  disabled: boolean;
};

const CategoriesListItem = ({ category, updateQuantityOfItemsInCategory, categoryQuantity, disabled }: Props) => {
  const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } = useNumberInput({
    step: 1,
    isDisabled: disabled,
    defaultValue: 0,
    min: 0,
    max: category.restaurantItemsCount,
    onChange: (valueAsString, valueAsNumber) => {
      const updatedValue =
        valueAsNumber > category.restaurantItemsCount ? category.restaurantItemsCount : valueAsNumber;
      updateQuantityOfItemsInCategory(category.id, updatedValue);
    },
    value: categoryQuantity,
  });

  return (
    <QuantityInput
      inputProps={{ ...getInputProps() }}
      decrementButtonProps={{ ...getDecrementButtonProps() }}
      incrementButtonProps={{ ...getIncrementButtonProps() }}
      disabled={disabled}
    />
  );
};

export default CategoriesListItem;
